// 创建WAV文件的Blob对象
function encodeWav(buffer, sampleRate) {
    var wavBuffer = new ArrayBuffer(44 + buffer.length * 2);
    var wavView = new DataView(wavBuffer);
    writeString(wavView, 0, 'RIFF');
    wavView.setUint32(4, 36 + buffer.length * 2, true);
    writeString(wavView, 8, 'WAVE');
    writeString(wavView, 12, 'fmt ');
    wavView.setUint32(16, 16, true);
    wavView.setUint16(20, 1, true);
    wavView.setUint16(22, 1, true);
    wavView.setUint32(24, sampleRate, true); // 采样率设置为8000Hz
    wavView.setUint32(28, sampleRate * 2, true); // 比特率设置为128kbps =8000(采样率) * 1（声道数） * 16/8 （位数）
    wavView.setUint16(32, 2, true);
    wavView.setUint16(34, 16, true);
    writeString(wavView, 36, 'data');
    wavView.setUint32(40, buffer.length * 2, true);
    for (var i = 0; i < buffer.length; i++) {
        var sample = Math.max(-1, Math.min(1, buffer[i]));
        wavView.setInt16(44 + i * 2, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
    }
    return new Blob([wavView], { type: 'audio/wav' });
}

// 写入字符串到DataView
function writeString(view, offset, string) {
    for (var i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
    }
}

//采样率指的是在一秒钟内对音频信号进行采样的次数。它以赫兹（Hz）为单位表示，表示每秒钟采集的样本数。
//常见的采样率有8000Hz、44100Hz、48000Hz等。较高的采样率可以更准确地还原原始音频信号，但同时也会增加文件的大小

//比特率指的是在单位时间内传输或处理的比特数量。它以比特每秒（bps）为单位表示，表示每秒传输的比特数。
//对于音频文件，比特率指的是每秒钟传输的音频数据量。较高的比特率可以提供更高质量的音频，但同时也会增加文件的大小

//采样率和比特率之间存在一定的关系。比特率可以通过以下公式计算：

//比特率 = 采样率 × 声道数 × 采样位数

//其中，声道数表示音频信号的通道数，常见的有单声道和立体声（双声道）；采样位数表示每个采样点的位数，常见的有8位、16位等。
class RecorderWav {

    constructor(option) {
        option = option || {};
        this.sampleRate = option.sampleRate || 8000; //采样率
        this.bitRate = option.bitRate || 128; //比特率，视频质量
        this.success = option.success || (() => console.log("开始录制"))
        this.error = option.error || (() => console.log("录制失败"))
    }

    //初始化
    init() {
        // 创建音频上下文对象
        var audioContext = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: this.sampleRate });
        this.audioContext = audioContext;
    }

    //开始录音
    start() {

        let audioContext = this.audioContext;
        let audioData = [];
        var that = this;
        // 获取用户媒体设备（麦克风）
        navigator.mediaDevices.getUserMedia({ audio: true })
            .then(function (stream) {
                // 创建MediaStreamAudioSourceNode
                var source = audioContext.createMediaStreamSource(stream);

                // 创建ScriptProcessorNode
                var scriptNode = audioContext.createScriptProcessor(4096, 1, 1);

                // 监听音频数据
                scriptNode.addEventListener('audioprocess', function (e) {
                    // 获取输入音频数据
                    var inputBuffer = e.inputBuffer.getChannelData(0);

                    // 将音频数据存储到数组中
                    audioData.push(new Float32Array(inputBuffer));
                });

                // 连接节点
                source.connect(scriptNode);
                scriptNode.connect(audioContext.destination);

                that.audioData = audioData;
                that.source = source;
                that.scriptNode = scriptNode;
                that.success();
            })
            .catch(function (error) {
                that.error();
                console.error('获取用户媒体设备失败:', error);
            });
    }

    //停止录音
    stop() {

        // 断开节点连接
        this.source.disconnect();
        this.scriptNode.disconnect();
        let audioContext = this.audioContext;
        let audioData = this.audioData;
        // 将音频数据合并为单个Float32Array
        var mergedAudioData = new Float32Array(audioData.length * 4096);
        var offset = 0;
        for (var i = 0; i < audioData.length; i++) {
            mergedAudioData.set(audioData[i], offset);
            offset += audioData[i].length;
        }

        // 创建AudioBuffer
        var audioBuffer = audioContext.createBuffer(1, mergedAudioData.length, this.sampleRate);
        audioBuffer.copyToChannel(mergedAudioData, 0);

        // 导出音频数据为WAV文件
        var blob = this.exportWav(audioBuffer);
        return blob;
    }

    //释放
    destory() {
        if (this.source) {
            this.stop();
        }

        this.source=null;
        this.scriptNode=null;
        this.audioContext=null;
        this.audioData=null;
    }

    // 导出音频数据为WAV文件
    exportWav(audioBuffer) {

        let sampleRate = this.sampleRate; //采样率
        let bitRate = this.bitRate; //比特率，视频质量

        // 导出WAV文件
        var blob = encodeWav(audioBuffer.getChannelData(0), sampleRate);
        return blob;
    }
}

export default RecorderWav;